import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/Header.css";
import logo from "../assets/images/TUC_logo_new.png";
import MegaMenu from "./MegaMenu";
import { Helmet } from "react-helmet-async";
import CustomNavbar from "./CustomNavbar";
const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProductHovered, setIsProductHovered] = useState(false);
  const location = useLocation();

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleNavbar = () => {
    setIsExpanded((prev) => !prev);
  };

  const toggleMenu  = (event: React.MouseEvent, isProducts: boolean = false, isLastItem = false) => { 
    //event.preventDefault(); // Prevent default anchor click behavior
    if (window.innerWidth <= 768) {  
        if (isProducts) {
          setIsExpanded(true); // Ensure Mega Menu opens when clicking "Products"
          }
        // else if(isLastItem)
        //   {
        //     setIsExpanded(false);
        //   } 
        else {
          setIsExpanded((prev) => !prev);
              }
     }
  }
  const closeMenu = () => {
    if (window.innerWidth <= 768) setIsMenuOpen(false);
  };

 const GetPageName = () =>{
    let path= location.pathname.split('/')[1].replace("aboutus","About Us:").replace("contactus", "Contact US:").replace("Products","Product :");
    console.log(path);
    return path + "Techmark Universal Company" ;
 }

 
  return (
    <>
      <div className="hederbar">
      <Helmet>
        <title>{GetPageName()} </title>
        <meta name="description" content="Techmark Universal Company specializes in the engineering, supply, installation, integration, testing, commissioning, and servicing of a wide range of Instrumentation, Gas Metering, Telecom products, Automation, Electrical, Mechanical, and other Industrial products. We provide cutting-edge solutions for measurement, monitoring, and control in highly demanding industries.
          Our valued customers come from diverse sectors, including Oil & Gas, Chemical, Pharmaceutical, Specialty gas, Defence, Automobile, Power & Energy, Metals, Mining, pharmaceuticals & life sciences, water & wastewater, food & beverage, and equipment manufacturing." />
        <meta name="keywords" content="Techmark Universal Company,specializes in the engineering, supply, installation, integration, testing, commissioning,servicing,Instrumentation, Gas Metering, Telecom, Automation, Electrical, Mechanical,solutions,measurement, monitoring,industries,Oil & Gas,Chemical, Pharmaceutical, Specialty gas, Defence, Automobile, Power & Energy, Metals, Mining, pharmaceuticals & life sciences, water & wastewater, food & beverage, equipment manufacturing." />
      </Helmet>
        <ul>
          <li>
            <i className="fa fa-phone text-theme-colored"></i> Contact :
            <a className="text-gray" href="tel:+91 635 932 0518"> +91 635 932 0518</a>
          </li>
          <li>
            <i className="fa fa-envelope text-theme-colored"></i> Email :
            <a className="text-gray" href="mailto:sales@tuc.org.in">sales@tuc.org.in</a> /
            <a className="text-gray" href="mailto:rahul@tuc.org.in">rahul@tuc.org.in</a>
          </li>
        </ul>
      </div>
      
      <header className="header">
        <div className="logo"> <Link to="/" >
          <img src={logo} alt="Company Logo" />
         Techmark Universal Company</Link>
          <div className="hamburger" onClick={toggleNavbar}>
            <span className="bar"></span><span className="bar"></span><span className="bar"></span></div>
            
          </div>
      
          {/* MegaMenu for Desktop */}
        {/* <MegaMenu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu}/> */}
        <CustomNavbar isExpanded={isExpanded}  toggleMenu={toggleMenu}/>

      </header>
    </>
  );
};

export default Header;
